module.exports = __webpack_public_path__ + "static/media/Visa.60c2093d.svg";